import { collections, type Collection } from "@/mocks/collections";
import { categories, type SiteCategory } from "@/mocks/site";

export function getCategory(slug: string): SiteCategory | undefined {
  return categories.find((item) => item.slug === slug);
}

export function getCollections(categorySlug?: string): Collection[] {
  if (!categorySlug || categorySlug === "all") return collections;
  return collections.filter((item) => item.category === categorySlug);
}

export function getCollectionById(id: string): Collection | undefined {
  return collections.find((item) => item.id === id);
}

export function getRelated(current: Collection, limit = 3): Collection[] {
  const sameCategory = collections.filter(
    (item) => item.category === current.category && item.id !== current.id
  );
  const others = collections.filter(
    (item) => item.category !== current.category && item.id !== current.id
  );
  return [...sameCategory, ...others].slice(0, limit);
}

export function getHotList(limit = 5): Collection[] {
  return collections.filter((item) => item.hot).slice(0, limit);
}

export function formatDate(value: string): string {
  const [year, month, day] = value.split("-");
  if (!year || !month || !day) return value;
  return `${year}年${Number(month)}月${Number(day)}日`;
}